import { render, staticRenderFns } from "./DisplayValue.vue?vue&type=template&id=1a040627&"
import script from "./DisplayValue.vue?vue&type=script&lang=js&"
export * from "./DisplayValue.vue?vue&type=script&lang=js&"
import style0 from "./DisplayValue.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports